import React from "react"
import { MdLocationOn, MdLocalShipping, MdPhone, MdShoppingCart, MdPerson, MdPayment, MdStore  } from "react-icons/md";

const ShippingInfo = ({ order }) => (
  <>
    <div>
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Order Information</h2>
      <div className="space-y-3">
        <p className="flex items-center text-gray-600">
          <MdShoppingCart className="mr-2 text-cyan-500" />
          Order ID: {order._id}
        </p>
        <p className="flex items-center text-gray-600">
          <MdPerson className="mr-2 text-cyan-500" />
          Customer Email: {order.user.email}
        </p>
        <p className="flex items-center text-gray-600">
          <MdPerson className="mr-2 text-cyan-500" />
          Customer Name: {order.user?.name}
        </p>
        <p className="flex items-center text-gray-600">
          <MdPayment className="mr-2 text-cyan-500" />
          Payment Method: {order.paymentInfo.type}
        </p>
        <p className="flex items-center text-gray-600">
          <MdStore className="mr-2 text-cyan-500" />
          Shop: {order.shop.name}
        </p>
      </div>
    </div>

    <div>
      <div className="flex items-center">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Shipping Information</h2>
      </div>
      <div className="space-y-3">
        <p className="flex items-center text-gray-600">
          <MdLocationOn className="mr-2 text-cyan-500" />
          Address: {`${order.shippingAddress.address1}, ${order.shippingAddress.address2}`}
        </p>
        <p className="flex items-center text-gray-600">
          <MdLocationOn className="mr-2 text-cyan-500" />
          {`${order.shippingAddress.city}, ${order.shippingAddress.province} ${order.shippingAddress.zipCode}`}
        </p>
        <p className="flex items-center text-gray-600">
          <MdLocalShipping className="mr-2 text-cyan-500" />
          Current Location: {order.userCurrentLocation.address}
        </p>
        <p className="flex items-center text-gray-600">
          <MdPhone className="mr-2 text-cyan-500" />
          Mobile Number: {order.user?.phoneNumber}
        </p>
      </div>
    </div>
  </>
)

export default ShippingInfo

